(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  function initialise() {
    if (observer) observer.disconnect();
    document.querySelectorAll('.cf-reveal').forEach(element => element.classList.remove('cf-waiting'));
    if (!reduce.matches && 'IntersectionObserver' in window && !document.documentElement.classList.contains('shopify-design-mode')) {
      document.body.classList.add('cf-motion');
      observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.remove('cf-waiting');
          observer.unobserve(entry.target);
        }
      }), { threshold: 0.08, rootMargin: '0px 0px 40px 0px' });
      document.querySelectorAll('.cf-reveal').forEach(element => {
        if (element.getBoundingClientRect().top > window.innerHeight) {
          element.classList.add('cf-waiting');
          observer.observe(element);
        }
      });
    }
    document.querySelectorAll('.cf-mobile-menu').forEach(menu => {
      if (menu.dataset.cfReady) return;
      menu.dataset.cfReady = 'true';
      menu.addEventListener('click', event => { if (event.target.closest('a')) menu.removeAttribute('open'); });
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
      });
      document.addEventListener('click', event => { if (!menu.contains(event.target)) menu.removeAttribute('open'); });
    });
    document.querySelectorAll('.cf-resource-menu, .cf-resource-mobile').forEach(menu => {
      if (menu.dataset.cfReady) return;
      menu.dataset.cfReady = 'true';
      menu.addEventListener('click', event => { if (event.target.closest('a')) menu.removeAttribute('open'); });
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape' && menu.open) {
          event.stopPropagation();
          menu.removeAttribute('open');
          menu.querySelector('summary').focus();
        }
      });
      document.addEventListener('click', event => { if (!menu.contains(event.target)) menu.removeAttribute('open'); });
    });
  }
  initialise();
  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('shopify:section:select', event => {
    event.target.querySelectorAll('.cf-waiting').forEach(element => element.classList.remove('cf-waiting'));
  });
  reduce.addEventListener('change', initialise);
})();
